(function() {
    $(document).ready(function() {
        if (!document.querySelector('.mod24VcRedesign') ||
        !document.querySelector('.lp-c24-quickchips-chips')) {
            return;
        }
        console.log('c24VCTracking');

        const dataAttributes = [
            'prefix',
            'position',
            'identifier',
            'suffix',
        ];

        window.c24Lp.createClickTracking(
            '.lp-c24-quickchips-link',
            dataAttributes,
            'xppset-chips',
        );

        const options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };
        let trackedChips = new Set();

        const chipCallback = window.c24Lp.createIntersectionCallback(
            trackedChips,
            dataAttributes,
            'xppset-chips:show',
            window.c24Lp.getMatomoEventCategory(),
        );

        const chipObserver = new IntersectionObserver(chipCallback, {
            ...options,
            threshold: 0.4,
        });
        const chipTargets = document.querySelectorAll('.lp-c24-quickchips-link');

        chipTargets.forEach((chip) => {
            chipObserver.observe(chip);
        });
    });
})();
